/* eslint-disable react/display-name */
import React from 'react';

export default () => (
    <svg
        className="load-more-loader"
        version="1.1"
        id="L4"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 55 55"
        width="50"
    >
        <circle stroke="none" cx="6" cy="25" r="4">
            <animate attributeName="opacity" dur="1.2s" values="0;1;0" repeatCount="indefinite" begin="0.12" />
        </circle>
        <circle stroke="none" cx="22" cy="25" r="4">
            <animate attributeName="opacity" dur="1.2s" values="0;1;0" repeatCount="indefinite" begin="0.24" />
        </circle>
        <circle stroke="none" cx="38" cy="25" r="4">
            <animate attributeName="opacity" dur="1.2s" values="0;1;0" repeatCount="indefinite" begin="0.36" />
        </circle>
    </svg>
);
